import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1156">
      <HeroSection data-id="element-1157" />
      <PainSection data-id="element-1158" />
      <TruthSection data-id="element-1159" />
      <ProductPresentation data-id="element-1160" />
      <ContentBreakdown data-id="element-1161" />
      <BenefitsSection data-id="element-1162" />
      <TestimonialsSection data-id="element-1163" />
      <ForYouSection data-id="element-1164" />
      <GuaranteeSection data-id="element-1165" />
      <BonusSection data-id="element-1166" />
      <ValueStack data-id="element-1167" />
      <FAQSection data-id="element-1168" />
      <ImpactPhrases data-id="element-1169" />
      <Footer data-id="element-1170" />
    </div>;
}